import {gql, useQuery} from '@apollo/client';

const GET_OAUTH_URL = gql`
  query GetOauthData($provider: String) {
      oauthUrl(provider: $provider) {
        url
    }
  }
`;

export const useGetOauthUrl = (
    provider: string = '',
    skip: boolean = false,
) => useQuery(GET_OAUTH_URL, {
    variables: {provider},
    skip,
})